export const CHAT_MAX_LENGTH = 100;

export interface BotStatus {
    running: boolean;
    state?: string;
    username?: string;
    server?: string;
    connectedSince?: string;
    ping?: number;
    packetsInPerSecond?: number;
    packetsOutPerSecond?: number;
    chunksLoaded?: number;
    entitiesTracked?: number;
}

export interface SessionInfo {
    linked: boolean;
    minecraftUsername?: string;
    minecraftUuid?: string;
    tokenExpiry?: string;
    lastRefreshed?: string;
    keepSessionAlive?: boolean;
    isExpired?: boolean;
    refreshFailed?: boolean;
    refreshFailedAt?: string;
    refreshFailureReasonKey?: string;
    refreshFailureDetail?: string;
}

export interface TaskParameterDef {
    name: string;
    type: string;
    required: boolean;
    defaultValue?: string;
    description?: string;
    optionSource?: string | null;
}

export interface TaskDef {
    name: string;
    description: string;
    parameters: TaskParameterDef[];
}

export interface PluginTasks {
    plugin: string;
    tasks: TaskDef[];
}

export interface TaskNode {
    id: string;
    pluginName: string;
    taskName: string;
    status: string;
    progress: number;
    statusMessage?: string;
    error?: string;
    startedAt: string;
    completedAt?: string;
    subtasks: TaskNode[];
    isPaused?: boolean;
    interceptDepth?: number;
    isIntercept?: boolean;
    interceptTask?: TaskNode;
}

export interface QueuedTask {
    id: string;
    pluginName: string;
    taskName: string;
}
